import { trigger, transition, style, animate } from '@angular/animations';

export const feedbackAnimation = [
  trigger('feedbackAnimation', [
    transition(':enter', [
      style({ opacity: 0, height: 0 }),
      animate('250ms ease', style({ opacity: 1, height: '*' }))
    ]),
    transition(':leave', [animate('250ms ease', style({ opacity: 0, height: 0 }))])
  ])
];
